import React from 'react'
import {
  PerformanceRange,
  PERFORMANCE_RANGE_LABELS,
} from '../../services/recommendations_api'
import ReactSelectWrapper from '../FormUtils/ReactSelectWrapper'
import type { SingleValue } from 'react-select'
import { colors } from '../../styles/tokens'

/** Ordered list of range options for the dropdown. */
const RANGE_OPTIONS: PerformanceRange[] = ['3m', '6m', '12m', 'ytd', 'all']

interface RangeSelectorProps {
  /** Currently selected time range. */
  value: PerformanceRange
  /** Callback fired when the user selects a different range. */
  onChange: (value: PerformanceRange) => void
  /** Optional additional CSS class names. */
  className?: string
}

/**
 * Dropdown selector for choosing a time range for performance data.
 *
 * Provides preset options (3m, 6m, 12m, YTD, All Time) that cover
 * common use cases for reviewing historical performance.
 */
export const RangeSelector: React.FC<RangeSelectorProps> = ({
  value,
  onChange,
  className,
}) => {
  const options = RANGE_OPTIONS.map((range) => ({
    label: PERFORMANCE_RANGE_LABELS[range],
    value: range,
  }))

  const handleChange = (option: unknown): void => {
    const typedOption = option as SingleValue<{
      label: string
      value: PerformanceRange
    }>
    if (!typedOption) return
    onChange(typedOption.value)
  }

  return (
    <ReactSelectWrapper
      className={className}
      options={options}
      value={options.find((option) => option.value === value)}
      onChange={handleChange}
      isSearchable={false}
      placeholder="Select range"
      styles={{
        control: (provided) => ({
          ...provided,
          backgroundColor: colors['surface'],
        }),
      }}
    />
  )
}
